import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from "recharts";

const CustomTooltip = ({ active, payload, label, module }) => {
    if (active && payload && payload.length) {
        const data = payload[0]?.payload || {};
        let heading = label;
        if (module === "usageSummary" && data["Platform"]) {
            heading = data["Platform"];
        }
        return (
            <div className="custom-tooltip" style={{
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                padding: '10px',
                whiteSpace: 'nowrap'
            }}>
                <p className="label" style={{ margin: '0 0 10px 0' }}>
                    {heading}
                </p>
                {Object.keys(data).filter(k => k !== "name" && !(module === "usageSummary" && k === "Platform")).map((key, index) => (
                    <p key={`item-${index}`} style={{ margin: '5px 0', color: payload[0]?.color || '#8884d8' }}>
                        {key} : <span style={{ color: '#8884d8' }}>{data[key] !== null && data[key] !== undefined ? data[key] : '-'}</span>
                    </p>
                ))}
            </div>
        );
    }
    return null;
};

const lineColors = [
    "#8884d8",
    "#82ca9d",
    "#f55b00",
    "#2c95d2",
    "#a52cd2",
    "#ff8800",
    "#bb44ff",
    "#0099cc",
    "#ff6b6b",
    "#ffa500",
    "#00d4ff",
    "#13c2c2",
    "#52c41a",
    "#fa8c16",
    "#722ed1",
    "#f5222d",
    "#1890ff",
    "#eb2f96",
    "#13a8a8"
]

export default function LineChartComponent({ type, module, data, height, width, lineState }) {


    return (
        <ResponsiveContainer width={"100%"} height={height}>

            <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                    dataKey="name"
                    padding={{ left: 30, right: 30 }}
                    angle={data?.length > 15 ? -45 : 0}
                    textAnchor={data?.length > 15 ? "end" : "middle"}
                    height={data?.length > 15 ? 60 : 30}
                    tickFormatter={(value) => value && value.length > 10 ? value.substring(0, 10) + '...' : value}
                />
                <YAxis allowDecimals={false} />
                <Tooltip wrapperStyle={{ zIndex: 9999 }} content={(module === "contentConsumption" || module === "communityEngagement" || module === "usageSummary") ? <CustomTooltip module={module} /> : undefined} />
                <Legend />
                {module === "teacherRegister" && (<>
                    {lineState?.l1 &&
                        <Line
                            type="monotone"
                            dataKey="Teachers"
                            stroke="#8884d8"
                            activeDot={{ r: 8 }}
                        />
                    }
                    {lineState?.l2 &&
                        <Line
                            type="monotone"
                            dataKey="Acquisition"
                            stroke="#f55b00" />
                    }
                    {lineState?.l3 &&
                        <Line
                            type="monotone"
                            dataKey="Parents"
                            stroke="#2c95d2" />
                    }
                    {lineState?.l4 &&
                        <Line
                            type="monotone"
                            dataKey="Educators"
                            stroke="#a52cd2" />
                    }

                </>)}
                {!module && (<>
                    <Line
                        type="monotone"
                        dataKey="pv"
                        stroke="#8884d8"
                        activeDot={{ r: 8 }}
                    />
                    <Line
                        type="monotone"
                        dataKey="uv"
                        stroke="#82ca9d" />
                    <Line
                        type="monotone"
                        dataKey="nv"
                        stroke="#f55b00" />
                </>)}
                {module === "individualContent" &&
                    (data?.length > 0 &&
                        Object.keys(data[0])
                            .filter((key) => key !== "name")
                            .map((key, index) => (
                                <Line
                                    key={key}
                                    type="monotone"
                                    dataKey={key}
                                    name={key}
                                    stroke={lineColors[index % lineColors.length]}
                                    activeDot={{ r: 8 }}
                                />
                            ))
                    )
                }
                {module === "contentConsumption" && (<>
                    <Line
                        type="monotone"
                        dataKey="Total Hours"
                        stroke="#8884d8"
                        activeDot={{ r: 8 }}
                    />
                </>)}
                {module === "usageSummary" && (<>
                    <Line
                        type="monotone"
                        dataKey="Total Hours"
                        stroke="#8884d8"
                        activeDot={{ r: 8 }}
                    />
                </>)}
                {module === "CourseProgress" && (<>
                    <Line
                        type="monotone"
                        dataKey="Total Enrollments"
                        name="Total Enrollments"
                        stroke="#ff8800"
                    />
                    <Line
                        type="monotone"
                        dataKey="Total Likes"
                        name="Total Likes"
                        stroke="#bb44ff"
                    />
                    <Line
                        type="monotone"
                        dataKey="Total Bookmarks"
                        name="Total Bookmarks"
                        stroke="#0099cc"
                    />
                    <Line
                        type="monotone"
                        dataKey="Total Certificates"
                        name="Total Certificates"
                        stroke="#8884d8"
                    />
                    <Line
                        type="monotone"
                        dataKey="Completion Rate"
                        name="Completion Rate"
                        stroke="#82ca9d"
                    />
                    <Line
                        type="monotone"
                        dataKey="Popular Course"
                        name="Popular Course"
                        stroke="#f55b00"
                    />
                    <Line
                        type="monotone"
                        dataKey="Popular Course Enrollments"
                        name="Popular Course Enrollments"
                        stroke="#2c95d2"
                    />

                </>)}
                {module === "activevsavgtimespent1" && (<>
                    {lineState?.l1 &&
                        <Line
                            type="monotone"
                            dataKey="Average Time Spent"
                            stroke="#8884d8"
                            activeDot={{ r: 8 }}
                        />
                    }
                </>)}
                {module === "activevsavgtimespent2" && (<>
                    {lineState?.l2 &&
                        <Line
                            type="monotone"
                            dataKey="Active user"
                            stroke="#8884d8"
                            activeDot={{ r: 8 }}
                        />
                    }
                </>)}
                {module === "consumption_graded" && (<>
                    {lineState?.l1 &&
                        <Line
                            type="monotone"
                            dataKey="NoOfResources"
                            stroke="#8884d8"
                            activeDot={{ r: 8 }}
                        />
                    }
                </>)}
                {module === "consumption_non_graded" && (<>
                    {lineState?.l1 &&
                        <Line
                            type="monotone"
                            dataKey="live"
                            stroke="#8884d8"
                            activeDot={{ r: 8 }}
                        />
                    }
                    {lineState?.l2 &&
                        <Line
                            type="monotone"
                            dataKey="completed"
                            stroke="#f55b00"
                            activeDot={{ r: 8 }}
                        />
                    }
                </>)}
                {module === "community_consumption" && (<>
                    {lineState?.l1 &&
                        <Line
                            type="monotone"
                            dataKey="ActiveUsers"
                            stroke="#8884d8"
                            activeDot={{ r: 8 }}
                        />
                    }
                    {lineState?.l2 &&
                        <Line
                            type="monotone"
                            dataKey="AverageSessionDuration"
                            stroke="#f55b00" />
                    }
                    {lineState?.l3 &&
                        <Line
                            type="monotone"
                            dataKey="ScreenPageViews"
                            stroke="#2c95d2" />
                    }
                    {lineState?.l4 &&
                        <Line
                            type="monotone"
                            dataKey="Sessions"
                            stroke="#a52cd2" />
                    }

                </>)}
                {module === "communityEngagement" && (<>
                    {lineState?.l1 &&
                        <Line
                            type="monotone"
                            dataKey="Unique Users"
                            stroke="#8884d8"
                            activeDot={{ r: 8 }}
                        />
                    }
                </>)}
                {module === "impactSummary" && (<>
                    <Line
                        type="monotone"
                        dataKey="Total Certificates"
                        name="Total Certificates"
                        stroke="#ff8800"
                    />
                    <Line
                        type="monotone"
                        dataKey="Total Enrollments"
                        name="Total Enrollments"
                        stroke="#bb44ff"
                    />
                </>)}
                {module === "userRetention" &&
                    (data.length > 0 && Array.from(new Set(data.flatMap(item => Object.keys(item).filter(key => key !== 'name')))).map((moduleName, index) => (
                        <Line
                            key={moduleName}
                            type="monotone"
                            dataKey={moduleName}
                            name={moduleName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                            stroke={lineColors[index % lineColors.length]}
                            activeDot={{ r: 10 }}
                        />
                    )))
                }
            </LineChart>
        </ResponsiveContainer>
    )
}